import React from 'react';
import {DashboardProvider} from './context';
import {PortfolioView} from './PortfolioView';
import {SolutionsView} from './SolutionsView';
import {KanbanView} from './KanbanView';
import {MatrixView} from './MatrixView';
import {FromToView} from './FromToView';
import type {PortfolioData} from './types';

export type ViewId = 'portfolio' | 'solutions' | 'kanban' | 'matrix' | 'fromto';

/**
 * Renders one leader file as the full prototype dashboard (5 views). The host page owns auth, the
 * version selector, sign-out, and the active view tab (`DashboardHeader`); this component owns only
 * the content for the selected view.
 */
export function PortfolioDashboard({data, activeView}: {data: PortfolioData; activeView: ViewId}): React.ReactElement {
  return (
    <DashboardProvider data={data}>
      <div style={{minHeight: '100%', background: '#F8FAFC', fontFamily: "'DM Sans', sans-serif", color: '#0F172A'}}>
        <div style={{maxWidth: 1400, margin: '0 auto', padding: '40px 48px'}}>
          {activeView === 'portfolio' && <PortfolioView />}
          {activeView === 'solutions' && <SolutionsView />}
          {activeView === 'kanban' && <KanbanView />}
          {activeView === 'matrix' && <MatrixView />}
          {activeView === 'fromto' && <FromToView />}
        </div>
      </div>
    </DashboardProvider>
  );
}
